// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtnContainer":"VbPqrS","addToCartIconTooltip":"_AVr5l","addToCartBtn":"AlpQKX","iconButton":"DiQZiJ","dummyTextForLoadingWidth":"RYPDxA"};